module.exports = __webpack_public_path__ + "img/Icon_Copy_gray.9ceb5b87.svg";